/******************************************************************************\
 * :$
 *
 * Copyright(c) 2021 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Home
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 10Nov2021 craig File created.
 \******************************************************************************/
import React, {useState} from "react";
import './Home.css';
import {Col, Container, Row} from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import {IUser} from "../../../models/user/IUser";
import {getSessionCookie} from "../../../context/context";


export const Home: React.VFC = () => {

    const [sessionUser] = useState<IUser>(getSessionCookie());

    const welcomeMsg = () => {
        if (sessionUser.UserID > 0) {
            return <h1>Welcome {sessionUser.FirstName + " " + sessionUser.LastName}</h1>
        } else {
            return <h1>Welcome</h1>
        }
    }

    const buildHelpLinks = () => {
        if (sessionUser.UserID > 0) {
            return <Row className={"help-row"}>
                <h3 className={"help-title"}>Let's Get Started!</h3>
                <ul>
                    <li key={"intro"}><a className={"help-docs"} href={"/resources/GS_Introduction.pdf"} rel={"noreferrer"} target={"_blank"}>Gold Standard Introduction (.pdf)</a></li>
                    <li key={"review"}><a className={"help-docs"} href={"/resources/GS_Review_Process_Summary.pdf"} rel={"noreferrer"} target={"_blank"}>Review Process Summary (.pdf)</a></li>
                    <li key={"indiv-review"}><a className={"help-docs"} href={"/resources/GS_Individual_Review.pdf"} rel={"noreferrer"} target={"_blank"}>Individual Review (.pdf)</a></li>
                    <li key={"group-review"}><a className={"help-docs"} href={"/resources/GS_Group_Review.pdf"} rel={"noreferrer"} target={"_blank"}>Group Review (.pdf)</a></li>
                </ul>
            </Row>
        }
        return <></>
    }

    const contactUsSection = () => {
        if (sessionUser.UserID <=0) {
            return <><p>If you are interested in becoming part of the Review Team or have other questions, please <a href="mailto:GSApplication@ceoroundtableoncancer.org?subject=Question about becoming a reviewer">Contact Us!</a></p></>
        }
        else {
            return <><p>If you are interested in becoming part of the Review Team or have other questions, please <a href={"guide"}>Contact Us!</a></p><p>If you are a member of the Review Team, login and let’s get started!</p></>
        }
    }

    return (
        <Container className="form-container" fluid>
            <Row>
                {welcomeMsg()}
            </Row>
            <Row className={"welcome"}>
                <p>The CEO Cancer Gold Standard&trade; Application Review Portal provides a collaborative environment
                    designed to facilitate the evaluation and review of submitted Gold Standard Applications.</p>
                <p>Only members of the Review Team have access to this site. The Review Team is comprised of representatives from CEO Roundtable on Cancer member organizations, Gold Standard accredited organizations and other strategic partners.</p>
                <p>If you are interested in applying for Gold Standard Accreditation, please go to the <a
                    href="https://www.cancergoldstandard.org" rel={"noreferrer"} target={"_blank"}>Application Portal</a>.
                </p>
                {contactUsSection()}
            </Row>
            <Row className={"timeline-guide"}>
                <Container className={"timeline-guide"}>
                    <Row className={"help-row"}>
                        <h3 className={"help-title"}>Monthly Review Cycle</h3>
                    </Row>
                    <Row className={"timeline-guide-img"}>
                        <img className={"timeline-image"} alt={"Guide"} src={"/images/timeline/GS_Guide.png"}/>
                    </Row>
                    <Row>
                        <h3>Your Guide</h3>
                    </Row>
                </Container>
            </Row>
            <Row className={"timeline-main"}>
                <Col className={"timeline-wrapper"}>
                    <div className={"signup-group-space"}>
                        <div>
                            <img className={"timeline-image"} alt={"find Review Team"} src={"/images/timeline/Find_Review_Team.png"}/>
                            <img className={"timeline-image"} alt={"Team Review"} src={"/images/timeline/Five_Person_Review_Team.png"}/>
                        </div>
                        <h4 className={"timeline-header"}>Sign up Open & Team Announced</h4>
                    </div>
                    <div className={"review-space"}>
                        <img className={"timeline-image"} alt={"Individual Review"} src={"/images/timeline/Individual_Review.png"}/>
                        <h4 className={"timeline-header"}>Individual Review</h4>
                    </div>
                    <div className={"signup-group-space"}>
                        <div>
                            <img className={"timeline-image"} alt={"Group Review"} src={"/images/timeline/Group_Review.png"}/>
                            <img alt={"Team Recommendation"} className={"timeline-image"} src={"/images/timeline/Team_Recommendation.png"}/>
                        </div>
                        <h4 className={"timeline-header"}>Group Review & Team Recommendation</h4>
                    </div>
                </Col>
            </Row>
            <Row className={"timeline"}>
                <Col className={"timeline-wrapper"}>
                    <div className={"timeline-marker"}></div>
                    <div className={"signup-group-space"}></div>
                    <div className={"timeline-marker"}></div>
                    <div className={"review-space"}></div>
                    <div className={"timeline-marker"}></div>
                    <div className={"signup-group-space"}></div>
                    <div className={"timeline-marker"}></div>
                </Col>
            </Row>
            <Row className={"timeline-main"}>
                <Col className={"timeline-wrapper"}>
                    <div className={"signup-group-space"}>
                        <div className={"sub-header-guide"}>1 week</div>
                    </div>
                    <div className={"review-space"}>
                        <div className={"sub-header-guide"}>3 week window</div>
                    </div>
                    <div className={"signup-group-space"}>
                        <div className={"sub-header-guide"}>1-2 hour video conference</div>
                    </div>
                </Col>
            </Row>
            {buildHelpLinks()}
        </Container>
    );
}

